export default class OrderLine {
  /**
   * Create new order line and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @param {string} value
   */
  set quantity (value) {
    this._quantity = parseInt(value)
  }

  /**
   * @return {Int}
   */
  get quantity () {
    return this._quantity
  }

  /**
   * @param {string} value
   */
  set unitPriceExclVat (value) {
    this._unitPriceExclVat = parseFloat(value)
  }

  /**
   * @return {Int}
   */
  get unitPriceExclVat () {
    return this._unitPriceExclVat
  }

  /**
   * @param {string} value
   */
  set unitPriceInclVat (value) {
    this._unitPriceInclVat = parseFloat(value)
  }

  /**
   * @return {Int}
   */
  get unitPriceInclVat () {
    return this._unitPriceInclVat
  }
}
